import {createThunkRoutine} from 'redux-thunk-routine';
import { CREATE_SUBJECT, GET_SUBJECTS } from './action-types';

export const CreateSubjectRoutine = createThunkRoutine(CREATE_SUBJECT);
export const GetSubjectsRoutine = createThunkRoutine(GET_SUBJECTS);
